<template>
    <Paper class='calculateRouter'>
        <m-panel
            ref="tablePage"
            :config="config"
            :totalData="totalData"
            :pageTotal="pageTotal"
            :loading="loading"
            :pageID="pageID"
            @selectChange="selectChange"
            @searchChange="searchChange"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            @element-change="elementChange"
            >
            <div slot="table-module-btn">
                <div class="icon-button">
                    <el-tooltip class="item" effect="dark" content="新增" placement="bottom"  v-has="'07010001'">
                        <el-button class="bigData-btn-add" type='primary' size="mini" icon='el-icon-plus' @click="addData"></el-button>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="刷新" placement="bottom">
                        <el-button class="bigData-btn-refresh" icon='el-icon-refresh' size="mini" @click="loadData" :loading="loading"></el-button>
                    </el-tooltip>
                </div>
            </div>
            <div slot="page-module-btn">
                <el-col>
                       <span v-has="'07010002'">
                    <el-button class="bigData-btn-save" type="primary" @click="saveData" :loading="loading">保存</el-button>
                        </span>
                       <span v-has="'07010003'" style="margin-left: 10px;">
                    <el-button class="bigData-btn-delete" type="primary" @click="delData" :loading="loading">删除</el-button>
                       </span>
                </el-col>
            </div>
        </m-panel>
    </Paper>
</template>
<script>
import mPanel from '@/components/otpPanel';
import Paper from '@/components/core/paper/Paper';
import config from './config.json';
import { dictWithUrl } from '@/components/lots/api';
import calculateRouterAPI from '../../../../api/contract/fileConfiguration';
export default {
    name: 'fileConfiguration',
    data() {
        return {
            config: config,
            totalData: [],
            pageTotal: 100,
            editState: false,
            selectedRows: [],
            loading: false,
            checkedData: [],
            pageNo: 1,
            pageSize: 10,
            pageID: 'lsrm_file_configuration_20250725',
            searchTerm: {},
            recoedArray: [],
            optionList: ['SRM_CONTRACT_WH_SERVICE_TYPE', 'SRM_CONTRACT_HANDLING_SERVICE_TYPE', 'SRM_CONTRACT_TRANS_SERVICE_TYPE', 'CONTRACT_IS_OVERSEAS'],
            services_etc: []
        };
    },
    methods: {
        addData() {
            this.$refs.tablePage.$refs.table.addRow();
        },
        selectChange(data) {
            // 表格内选择变化
            data.map(item => {
                this.validatePropsIsDisabled(item);
            });
            if (data.length > 0) {
                this.checkedData = data;
            } else {
                this.checkedData = [];
            }
        },
        searchChange(data) {
            this.pageNo = 1;
            this.searchTerm = data;
            this.loadData();
        },
        pageChange(data) {
            this.pageNo = data;
            this.loadData();
        },
        sizeChange(data) {
            this.pageSize = data;
            this.loadData();
        },
        saveData() {
            const that = this;
            const data = this.checkedData;
            const paramsLists = [];
            data.forEach(item => {
                if (this.recoedArray.length !== 0) {
                    for (let key = 0; key < this.recoedArray.length; key++) {
                        if (item.id === this.recoedArray[key].id && this.recoedArray[key].isEnable === '1') {
                            item.isEnable = item.isEnable === 'Y' ? '1' : '0';
                            paramsLists.push(item);
                            break;
                        } else if (item.id === this.recoedArray[key].id) {
                            item.isEnable = item.isEnable === 'Y' ? '1' : '0';
                            paramsLists.push(item);
                            break;
                        } else if (item.id === undefined) {
                            item.isEnable = item.isEnable === 'Y' ? '1' : '0';
                            paramsLists.push(item);
                            break;
                        }
                    }
                } else {
                    item.isEnable = item.isEnable === 'Y' ? '1' : '0';
                    paramsLists.push(item);
                }
            });
            if (data.length !== 0) {
                calculateRouterAPI.save(paramsLists).then(res => {
                    if (res) {
                        this.$message.success('保存成功！');
                        that.loadData();
                    }
                });
            }
        },
        delData() {
            const that = this;
            const routes = this.checkedData;
            if (routes.length === 0) {
                this.$message.warning('请勾选需要删除的数据');
            } else {
                const ids = [];
                routes.map(item => {
                    if (item.id) {
                        ids.push(item.id);
                    }
                });
                if (!ids.length) {
                    this.loadData();
                    return;
                }
                calculateRouterAPI.del(ids).then(res => {
                    if (res.code === '0') {
                        this.$message.success('删除成功！');
                        that.loadData();
                    } else {
                        this.$message.error(res.$message);
                    }
                });
            }
        },
        loadData() {
            this.loading = true;
            const params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                ...this.searchTerm,
                orderBy: 'create_time',
                orderByType: 'desc',
            };
            calculateRouterAPI.search(params).then(res => {
                this.pageTotal = res.data.totalCount;
                this.totalData = res.data.list;
                this.recoedArray = JSON.parse(JSON.stringify(res.data.list));
                for (let i = 0; i < this.totalData.length; i++) {
                    this.totalData[i].isRequired = String(this.totalData[i].isRequired);
                    this.totalData[i].stampCategory = String(this.totalData[i].stampCategory);
                    this.totalData[i].isEnable = this.totalData[i].isEnable === '1' ? 'Y' : 'N';
                }
                this.editState = false;
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            });
        },
        // 校验属性禁用规则
        validatePropsIsDisabled(row) {
            let recordIsEnable;
            this.recoedArray.forEach(item => {
                if (item.id === row.id) {
                    recordIsEnable = (item.isEnable === '1' ? '0' : '1');
                }
            });
            if (recordIsEnable === '0') {
                row.disableProps = ['applyType', 'fileType', 'fileName', 'isRequired', 'stampCategory'];
            }
        },
        elementChange(data) {
            if (data.prop === 'businessType') {
                if (data.val === '1') {
                    this.loopFor(this.services_etc[0], data);
                } else if (data.val === '2') {
                    this.loopFor(this.services_etc[1], data);
                } else {
                    this.loopFor(this.services_etc[2], data);
                }
            } else if (data.prop === 'servicesType') {
                if (this.reBool(this.services_etc[0], data)) {
                    if (data.row.businessType !== '1') {
                        data.row.businessType = '';
                    }
                } else if (this.reBool(this.services_etc[1], data)) {
                    if (data.row.businessType !== '2') {
                        data.row.businessType = '';
                    }
                } else {
                    if (this.reBool(this.services_etc[2], data)) {
                        if (data.row.businessType === '1' || data.row.businessType === '2') {
                            data.row.businessType = '';
                        }
                    }
                }
            }
        },
        loopFor(arr, data, val) {
            for (let i = 0; i < arr.length; i++) {
                const element = arr[i];
                if (data.row.servicesType === element.value) {
                    break;
                } else if (i < (arr.length - 1)) {
                    continue;
                } else {
                    data.row['servicesType'] = '';
                }
            }
        },
        reBool(arr, data) {
            for (let i = 0; i < arr.length; i++) {
                const element = arr[i];
                if (data.val === element.value) {
                    return true;
                } else if (i < (arr.length - 1)) {
                    continue;
                } else {
                    return false;
                }
            }
        },
        dictoptionNum(comback) {
            this.services_etc = [];
            const optionString = this.optionList.join(',');
            dictWithUrl(optionString).then(res => {
                this.optionList.map(num => {
                    const option = [];
                    for (const key in res.data[num]) {
                        if (res.data[num].hasOwnProperty(key)) {
                            option.push({ 'value': key, 'label': res.data[num][key] });
                        }
                    }
                    this.services_etc.push(option);
                });
            });
        }

    },
    created() {
        this.dictoptionNum();
        this.loadData();
    },
    components: { Paper, mPanel }
};
</script>
<style lang='less'>
   .calculateRouter{
        padding: 9px 16px 10px 16px !important;
   }
</style>
